import React from 'react';
import PropTypes from 'prop-types';
import Button from 'wonderbly-components/lib/Button';
import Panel from 'wonderbly-components/lib/Panel';
import cx from 'classnames';

import './DiscountForm.scss';

const DiscountForm = props => (
  <Panel className="discount-form">
    <form onSubmit={props.handleSubmit}>
      <input
        className={cx('discount-form-input', {
          'discount-form-input--error':
            props.cartErrors && props.cartErrors.length > 0,
        })}
        type="text"
        name="code"
        placeholder={props.placeholder}
        onChange={props.handleChange}
        value={props.values.code}
        onClick={props.handleClick}
      />
      <Button
        colour="green"
        outlined={!!props.values.code}
        disabled={!props.values.code}
        className="discount-cta-button"
        type="submit">
        {props.cta}
      </Button>
    </form>
  </Panel>
);

DiscountForm.propTypes = {
  description: PropTypes.array,
  cta: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  cartErrors: PropTypes.array,
  values: PropTypes.shape({
    code: PropTypes.string
  }),
  country: PropTypes.shape({
    locale: PropTypes.string.isRequired,
    currency: PropTypes.string
  }).isRequired,
  globalContent: PropTypes.shape({
    success: PropTypes.shape({
      addDiscountCode: PropTypes.array.isRequired
    }).isRequired,
  }).isRequired,
  isTwoColumnLayout: PropTypes.bool,
  handleClick: PropTypes.func,
};

export default DiscountForm;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CartSummary/DiscountForm/DiscountForm.js